import { defineMessages } from 'react-intl';

export const signUpModalMessages = defineMessages({
  joinPartnerTitle: {
    defaultMessage: 'Join {partnerName}',
    id: 'W0YsS3JUre',
    description: 'Signup modal title in white-label mode with partner name',
  },
  titleDefault: {
    defaultMessage: 'Join Heidi, save hours',
    id: '7mpas5cr6v',
    description: 'Default signup modal title',
  },
  titleVariant1: {
    defaultMessage: "Join Heidi, it's free",
    id: 'gzy3UU2PR6',
    description: 'Signup modal title variant 1',
  },
  titleVariant2: {
    defaultMessage: 'Join Heidi, work smarter',
    id: 'M+cboP7heO',
    description: 'Signup modal title variant 2',
  },
  titleVariant3: {
    defaultMessage: 'Join Heidi, see patients faster',
    id: 'e6YmpQ8Jih',
    description: 'Signup modal title variant 3',
  },
  titleVariant4: {
    defaultMessage: 'Join Heidi, free your time',
    id: 'eeGOzroTuf',
    description: 'Signup modal title variant 4',
  },
  subtitleDefault: {
    defaultMessage: '40 million hours returned and counting',
    id: 'RWSVonoBPY',
    description: 'Default signup modal subtitle',
  },
  subtitleVariant1: {
    defaultMessage: 'Your AI assistant for patient notes.',
    id: '6i4tHjWC+l',
    description: 'Signup modal subtitle variant 1',
  },
  subtitleVariant2: {
    defaultMessage: 'The AI co-pilot for your clinic.',
    id: 'xq73GjvkHX',
    description: 'Signup modal subtitle variant 2',
  },
  subtitleVariant3: {
    defaultMessage: 'Automate notes, focus on care.',
    id: 'xXEsGzrIWU',
    description: 'Signup modal subtitle variant 3',
  },
  subtitleVariant4: {
    defaultMessage: 'Smarter documentation, less stress.',
    id: '1xj1ev8lce',
    description: 'Signup modal subtitle variant 4',
  },
  firstNameLabel: {
    defaultMessage: 'First name',
    id: 'Xxmqy6tfks',
    description: 'Label for first name field on signup',
  },
  firstNamePlaceholder: {
    defaultMessage: 'Jane',
    id: 'ZGlDAC0ipU',
    description: 'Placeholder example for first name on signup',
  },
  lastNameLabel: {
    defaultMessage: 'Last name',
    id: 'UvodMGQa8X',
    description: 'Label for last name field on signup',
  },
  lastNamePlaceholder: {
    defaultMessage: 'Doe',
    id: 'Owe7WY1Iw6',
    description: 'Placeholder example for last name on signup',
  },
  workEmailLabel: {
    defaultMessage: 'Work email',
    id: 'ERUURcbHlG',
    description: 'Label for work email field on signup',
  },
  workEmailPlaceholder: {
    defaultMessage: 'name@company.com',
    id: 'v+GP2H2g/Y',
    description: 'Placeholder for work email on signup',
  },
  workEmailHint: {
    defaultMessage:
      'While you can use any email to access Heidi, consider using your work email for a better experience.',
    id: '+up1jg/EPe',
    description: 'Hint shown under work email when personal email domain is detected',
  },
  succinctWorkEmailHint: {
    defaultMessage: 'We recommend using a work email for a better experience',
    id: 'PtUVQKgA5y',
    description: 'Shorter hint under work email when feature flag is on',
  },
  specialtyLabel: {
    defaultMessage: 'Specialty',
    id: 'Hw/E8MtAWT',
    description: 'Label for specialty dropdown on signup',
  },
  countryLabel: {
    defaultMessage: 'Country',
    id: 'XBn03SopnU',
    description: 'Label for country dropdown on signup',
  },
  displayLanguageLabel: {
    defaultMessage: 'Language',
    id: 'gX+OLJZ06e',
    description: 'Label for display language dropdown on signup',
  },
  phoneNumberOptional: {
    defaultMessage: 'Phone number (optional)',
    id: 'A+40GmWcch',
    description: 'Label when phone number is optional on signup',
  },
  phoneNumberLabel: {
    defaultMessage: 'Phone number',
    id: 'm/GlbhDXCN',
    description: 'Label when phone number is required on signup',
  },
  phoneNumberPlaceholder: {
    defaultMessage: 'Enter a phone number',
    id: '30vzwNLbgA',
    description: 'Placeholder in phone number field on signup',
  },
  joinForFree: {
    defaultMessage: 'Join for free',
    id: 'oKsVlYMTet',
    description: 'Primary CTA to submit signup with email',
  },
  signInWithEmail: {
    defaultMessage: 'Sign in with email',
    id: 'wKfwjhIV2L',
    description: 'Primary CTA when using Kinde email connection',
  },
  termsRequiredTitle: {
    defaultMessage: 'Terms agreement required',
    id: 'H1yavXsVda',
    description: 'Toast title when user submits signup without accepting terms',
  },
  termsRequiredDescription: {
    defaultMessage: 'Please agree to the Terms of Use to continue',
    id: 'OrNlcYT7ad',
    description: 'Toast body when user submits signup without accepting terms',
  },
  googleLogoAlt: {
    defaultMessage: 'google logo',
    id: 'aMtyMDchX6',
    description: 'Alt text for Google logo on signup',
  },
  appleLogoAlt: {
    defaultMessage: 'apple logo',
    id: 'av6cKmvMjs',
    description: 'Alt text for Apple logo on signup',
  },
  signUpWithGoogle: {
    defaultMessage: 'Sign up with Google',
    id: 'BsiTtivwOu',
    description: 'Button label for Google signup',
  },
  signUpWithApple: {
    defaultMessage: 'Sign up with Apple',
    id: 'i9xd4dyBUV',
    description: 'Button label for Apple signup',
  },
  alreadyHaveAccount: {
    defaultMessage: 'Already have an account? Log in',
    id: 'wKdslf8E3I',
    description: 'Link text to log in from signup modal',
  },
});
